
    <div class="profile-picture">
        {{ userName | nameInitials}}
    </div>
